import { render, staticRenderFns } from "./ReferralsPatientDetailsModal.vue?vue&type=template&id=25f39cf1&scoped=true"
import script from "./ReferralsPatientDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReferralsPatientDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralsPatientDetailsModal.vue?vue&type=style&index=0&id=25f39cf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f39cf1",
  null
  
)

export default component.exports